import { Directive, Host, OnDestroy, OnChanges, Input, Output, EventEmitter } from '@angular/core';

import { DatatableComponent } from '../../components/datatable/components/datatable.component';
import { TableSort } from '../../components/datatable/types/sort.type';
import { SortDirection } from '../../components/datatable/types/sort-direction.type';
import { SortEvent } from '../../domain/data-table.domain';
import { TableStateBaseDirective } from './table-state-base.directive';
import { TableStateService } from './table-state.service';

@Directive({
  selector: '[tdWbTableState]'

})
export class TableStateDirective extends TableStateBaseDirective implements OnChanges, OnDestroy {
  @Input('tdWbTableState')
  set tableId(value: string) {
    this.stateId = value;
  }

  @Input() stateResetEnabled: boolean = false;
  @Output() readonly stateResetChange: EventEmitter<Array<TableSort>> = new EventEmitter();

  constructor(tableStateService: TableStateService,
              @Host() private datatableComponent: DatatableComponent) {
    super(tableStateService, datatableComponent.sort);
  }

  ngOnChanges(): void {
    this.datatableComponent.sorts = this.getSorts();
  }

  ngOnDestroy(): void {
    this.destroy();
  }

  onSort(sort: SortEvent): void {
    let sorts = sort.sorts;
    if (this.stateResetEnabled && sort.newValue === SortDirection.ASC && sort.prevValue === SortDirection.DESC) {
      sorts = this.getDefaultSorts();
      this.datatableComponent.sorts = sorts;
      this.stateResetChange.emit(sorts);
    }
    this.setSorts(sorts);
  }
}
